<template>
    <div class="sign-details-dialog">
        <el-dialog title="签署详情" v-dialogDrag :visible.sync="visible" :before-close="onClose">
            <template v-if="visible" >
                <el-table  :data="tableData" :height="380" border stripe v-loading="loading" style="width: 100%">
                    <el-table-column
                        show-overflow-tooltip
                        prop="signBatchNo"
                        width="170"
                        label="签署编号"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="signFileCode" label="文件编号" width="120"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="signerName" label="签署人"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="signerPhone" width="120" label="签署手机">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="_signStatus" label="签署状态">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="_signTime" width="150" label="签署时间">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="_signTime" width="80" label="签署文件">
                        <template slot-scope="scope">
                            <el-button type="text" v-if="scope.row.canDownloadFlag" @click="handleBtnClick(scope.row, '下载')">下载</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="failureReason" label="签署失败原因" width="120">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="_signType" width="150" label="类型">
                    </el-table-column>
    
                    <el-table-column show-overflow-tooltip prop="portraitContractStatus" label="操作" fixed="right">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.pushButton" type="text" @click="onRePush(scope.row)">重推</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-row type="flex" class="row-page" justify="space-between">
                    <el-col :offset="12" :span="12">
                        <m-page
                            ref="page"
                            :current-page="currentPage"
                            :pageData="pageConfig"
                            :total="pageTotal"
                            @on-page-change="pageChange"
                            @on-size-change="sizeChange"></m-page>
                    </el-col>
                </el-row>
            </template>
            <!-- <span slot="footer">
              <el-button @click="onClose">取 消</el-button>
              <el-button type="primary" @click="onClose">关闭</el-button>
          </span> -->
        </el-dialog>
    </div>
</template>
<script>
// import bigDataLog from '@/utils/bigDataLog'
import mPage from '@/components/supplierPanel/mPage'
// import dayjs from 'dayjs'
import { dictWithUrl } from '@/components/lots/api'
import {
    recordPage,
    getRePush
} from '../../../api/warehouseResourceManagement/warehouseDelegationLetter.js'
import Preview from '../../../components/viewAttachment.vue';
export default {
    components: { mPage },
    props: {
        checkedData: {
            type: Array,
            default: function () {
                return []
            },
        },
        conditions: {
            type: String,
            default: function () {
                return ''
            },
        },
    },
    data() {
        return {
            warehouseDelegateNo:'',
            businessType: '',
            pageTotal: 0,
            pageNo: 1,
            pageSize: 10,
            totalCount: 0,
            currentPage: 1,
            pageConfig: {
                layout: 'total, sizes, prev, pager, next',
                pageSize: 10,
            },
            tableData: [],
            dictData: {}, // 数字字典
            loading: false,
            visible: false,
        }
    },
    methods: {
        show(warehouseDelegateNo) {
            this.visible = true
            this.tableData =[];
            this.warehouseDelegateNo = warehouseDelegateNo
            this.getData()
        },
        onClose() {
            this.visible = false
        },
        pageChange(pageNo) {
            this.pageNo = pageNo
            this.getData()
        },
        sizeChange(size) {
            this.pageSize = size
            this.getData()
        },
        //重推
        onRePush(data){
            if(data.id===null||data.id===''||data.id===undefined){
                this.$message.warning('id无效');
                return
            }
            this.loading = true
            getRePush(data.id)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('重推成功');
                        this.loadData()
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        getData() {
            // 签署状态 signStatus 数据字典  WAREHOUSE_SIGN_STATUS
            // 签署类型 signType 数据字典  WAREHOUSE_SIGN_TYPE
            dictWithUrl('WAREHOUSE_SIGN_STATUS,WAREHOUSE_SIGN_TYPE').then(res => {
                this.dictData = res.data
                this.loadData()
            })
        },
        async loadData() {
            this.loading = true;
                const params = {
                    warehouseDelegateNo:this.warehouseDelegateNo,
                    pageNo: this.pageNo,
                    pageSize: this.pageSize
                };
            const res = await recordPage(params);
            this.loading = false;
            if (res && res.code === '0') {
                const {list,totalPage,totalCount}=res.data;
                this.pageTotal =totalCount;
                let dataList=[];
                if(Array.isArray(list)&&list.length){
                    dataList = this.conversionData(list);
                }
                this.tableData = dataList;
            }
        },
        conversionData(list) {
            list.map(item => {
                item._signStatus = this.dictData.WAREHOUSE_SIGN_STATUS[item.signStatus]            // 签署状态 signStatus 数据字典  WAREHOUSE_SIGN_STATUS
                item._signType = this.dictData.WAREHOUSE_SIGN_TYPE[item.signType]           // 签署类型 signType 数据字典  WAREHOUSE_SIGN_TYPE
                item._signTime = item.signTime
            })
            return list
        },
        // 签署文件点击下载
        handleBtnClick(row, buttonName) {
            try {
                if(this.downloading) return
                this.downloading = true
                const val = row.downloadUrl
                // console.log('handleBtnClick', val, buttonName)
                if (!val) {
                    return this.$message.warning('暂无附件!')
                }
                let a = document.createElement('a');
                a.href = val;
                a.click();
                // 200毫秒节流
                setTimeout(() => {
                    this.downloading = false
                }, 200);
            }
            catch(error) {
                this.downloading = false
                this.$message.warning('下载失败:', error)
            }
        },
    },
}
</script>
<style scoped lang="less">
/deep/.el-dialog{
    width: 1100px !important;
}
.sign-details-dialog {
    .row-page {
        margin-top: 20px;
    }
    .blue-color {
        cursor: pointer;
        color: #00bcbf;
    }
    .gray-color {
        color: #888888;
    }
}
</style>
